import { render, staticRenderFns } from "./page-create-animation.vue?vue&type=template&id=61582f02&scoped=true"
import script from "./page-create-animation.vue?vue&type=script&lang=ts"
export * from "./page-create-animation.vue?vue&type=script&lang=ts"
import style0 from "./page-create-animation.vue?vue&type=style&index=0&id=61582f02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61582f02",
  null
  
)

export default component.exports